import { Component, Input, OnChanges } from '@angular/core';
import { AssociacaoItem, AssociacoesParsePipe } from '@core/pipes/associacoes-parse.pipe';



@Component({
  selector: 'app-associacoes-badges-nz',
  templateUrl: './associacoes-badges-nz.component.html',
  styleUrls: ['./associacoes-badges-nz.component.scss'],
  providers: [AssociacoesParsePipe]
})
export class AssociacoesBadgesNzComponent implements OnChanges {
  @Input() valor: string | string[] | null = null; // string "A (Default), B (X)" ou string[]
  @Input() maxVisiveis = 4;

  itens: AssociacaoItem[] = [];
  expandido = false;

  constructor(private parser: AssociacoesParsePipe) {}

  ngOnChanges(): void {
    this.itens = this.parser.transform(this.valor ?? '');
  }

  get visiveis(): AssociacaoItem[] {
    return this.expandido ? this.itens : this.itens.slice(0, this.maxVisiveis);
  }

  get restantes(): number {
    return Math.max(0, this.itens.length - this.visiveis.length);
  }

  toggle(): void {
    this.expandido = !this.expandido;
  }

  tooltip(i: AssociacaoItem): string {
    return i.subtipo ? `${i.entidade} — ${i.subtipo}` : i.entidade;
  }

isDefault(i: AssociacaoItem): boolean {
  const subtipo = (i.subtipo ?? '').trim().toLowerCase();
  return subtipo === 'default' || subtipo === 'defaut';
}
}
